// AI Generated Component
import { Component, OnInit } from '@angular/core';
import { StateService } from '@uirouter/core';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { SessionService } from '@monsido/core/session/session.service';
import { DateRangeService } from '@client/app/services/date-range/date-range.service';
import { ParamService } from '@monsido/ng2/core/param/param.service';
import { StatsRepoService } from '@client/app/services/api/stats-repo/stats-repo.service';
import { PipeService } from '@client/app/filters/pipe-transformation.service';
import { contextTokens } from '@monsido/ng2/services/request-auxiliary/request-auxiliary.service';
import moment from 'moment';

@Component({
    selector: 'statistics-visitors-cities',
    standalone: false,
    templateUrl: './cities.component.html',
})
export class StatisticsVisitorsCitiesComponent implements OnInit {
    domain: any;
    totalVisits: number = 0;
    date: any;
    countryCode: string = '';
    regionCode: string = '';
    countryName: string = '';
    regionName: string = '';
    pages: any[] = [];
    doughnutLabels: any[] = [];
    doughnutData: any[] = [];
    doughnutOptions: any = {};
    loading: boolean = false;
    promise: any;
    summary: any = {};
    loaded: boolean = false;
    page: number = 1;
    pageSize: number = 10;

    constructor (
        private statsRepoService: StatsRepoService,
        private stateService: StateService,
        private paramService: ParamService,
        private translateService: TranslateService,
        private sessionService: SessionService,
        private dateRangeService: DateRangeService,
        private pipeService: PipeService,
    ) {}

    ngOnInit () {
        this.activate();
    }

    activate () {
        this.domain = this.sessionService.domain;
        this.totalVisits = 0;
        this.date = this.dateRangeService.setRangeDates();
        this.countryCode = this.stateService.params.countryCode;
        this.regionCode = this.stateService.params.regionCode;
        this.countryName = this.stateService.params.countryName || this.countryCode;
        this.regionName = this.stateService.params.regionName || this.regionCode;

        this.setupDoughnutSettings();
        this.updateDateRange();
    }

    setupDoughnutSettings () {
        this.doughnutLabels = [];
        this.doughnutData = [];
        this.doughnutOptions = {
            legend: {
                display: true,
                position: 'bottom',
                onHover: function (element: any) {
                    element.target.style.cursor = 'pointer';
                },
                onLeave: function (element: any) {
                    element.target.style.cursor = 'default';
                },
            },
            tooltips: {
                callbacks: {
                    title: () => {
                        return this.translateService.getString('Visits');
                    },
                    label: (tooltipItem: any, data: any) => {
                        return this.pipeService.get('monNumber')(data.datasets[0].data[tooltipItem.index]);
                    },
                },
            },
        };
    }

    getPage () {
        const params = {
            limit: 100,
            page: this.page || 1,
            domainId: this.stateService.params.domainId,
            region_label: this.regionName,
            country_code: this.countryCode,
            from: this.date.startDate.format('YYYY-MM-DD'),
            to: this.date.endDate.format('YYYY-MM-DD'),
        };

        const paramsVisitors = {
            domainId: this.stateService.params.domainId,
            from: this.date.startDate.format('YYYY-MM-DD'),
            to: this.date.endDate.format('YYYY-MM-DD'),
            search: this.regionName,
        };

        this.loading = true;

        this.promise = this.statsRepoService.getCities(params).then((data: any) => {
            this.pages = data;
            this.totalVisits = data.reduce((total: number, page: any) => {
                return total + parseInt(page.visits);
            }, 0);
            this.setupDoughnutData();
        });

        this.statsRepoService.getRegions(paramsVisitors, contextTokens.NO_PARSE_SEARCH)
            .then((data: any) => {
                if (data.length >= 1) {
                    this.summary = data[0];
                    this.summary.pageviews = 1;
                    if (parseInt(this.summary.visits) > 0 && parseInt(this.summary.avg_time) > 0) {
                        this.summary.avg_time = this.summary.avg_time / this.summary.visits;
                    }

                    if (parseInt(this.summary.visits) > 0 && parseInt(this.summary.bounce_rate) > 0) {
                        const bounceRate = this.summary.bounce_rate / this.summary.visits;
                        this.summary.bounce_rate = this.pipeService.get('monNumber')(bounceRate, '0.[00]%');
                    }

                    if (parseInt(this.summary.visits) > 0 && parseInt(this.summary.actions) > 0) {
                        const avgActions = this.summary.actions / this.summary.visits;
                        this.summary.avg_actions = this.pipeService.get('monNumber')(avgActions, '0.[00]');
                    }
                } else {
                    this.summary = null;
                }
            })
            .finally(() => {
                this.loaded = true;
            });
    }

    setupDoughnutData () {
        let others = 0;
        this.doughnutLabels = [];
        this.doughnutData = [];
        for (let i = 0; i < this.pages.length; i++) {
            if (i < 5) {
                this.doughnutLabels.push(this.pages[i].label);
                this.doughnutData.push(this.pages[i].visits);
            } else {
                others += parseInt(this.pages[i].visits);
            }
        }
        if (this.pages.length > 5) {
            this.doughnutLabels.push(this.translateService.getString('Others'));
            this.doughnutData.push(others);
        }
    }

    pageChange (page: number) {
        this.page = page;
        this.getPage();
    }

    perPageChange (pageSize: number) {
        this.pageSize = pageSize;
        this.getPage();
    }

    updateDateRange () {
        this.paramService.setParams({
            from: moment(this.date.startDate),
            to: moment(this.date.endDate),
            countryName: this.countryName,
            regionName: this.regionName,
        });
        this.getPage();
    }
}
